import { UserStatus } from '../types/UserStatus.enum'
import { MenuItem } from '../types/MenuItem.type'
import { UserResponse } from '@ampcore/client-side-services'
import { AdvisorData } from '../types/AdvisorData.type'

export interface AppState {
  menuName?: string | null
  menuItems?: MenuItem[] | null
  menuError?: string | null
  ampUserStatus?: UserStatus
  userData?: UserResponse | null
  advisorData?: AdvisorData | null
  advisorDataLoading?: boolean
  advisorDataError?: string | null
  isMenuLoading?: boolean
}

export enum ActionType {
  SET_MENU_NAME = 'SET_MENU_NAME',
  SET_MENU_ITEMS = 'SET_MENU_ITEMS',
  SET_MENU_ERROR = 'SET_MENU_ERROR',
  SET_AMP_USER_STATUS = 'SET_AMP_USER_STATUS',
  SET_USER_DATA = 'SET_USER_DATA',
  SET_ADVISOR_DATA = 'SET_ADVISOR_DATA',
  SET_ADVISOR_DATA_LOADING = 'SET_ADVISOR_DATA_LOADING',
  SET_ADVISOR_DATA_ERROR = 'SET_ADVISOR_DATA_ERROR',
  SET_MENU_LOADING = 'SET_MENU_LOADING'
}

export type Action =
  | { type: ActionType.SET_MENU_NAME; payload: string | null }
  | { type: ActionType.SET_MENU_LOADING; payload: boolean }
  | { type: ActionType.SET_MENU_ITEMS; payload: MenuItem[] }
  | { type: ActionType.SET_MENU_ERROR; payload: string | null }
  | { type: ActionType.SET_AMP_USER_STATUS; payload: UserStatus }
  | { type: ActionType.SET_USER_DATA; payload: UserResponse | null }
  | { type: ActionType.SET_ADVISOR_DATA; payload: AdvisorData | null }
  | { type: ActionType.SET_ADVISOR_DATA_LOADING; payload: boolean }
  | { type: ActionType.SET_ADVISOR_DATA_ERROR; payload: string | null }

export const initialState: AppState = {
  menuName: null,
  menuItems: null,
  menuError: null,
  ampUserStatus: undefined,
  userData: null,
  advisorData: null,
  advisorDataLoading: false,
  advisorDataError: null,
  isMenuLoading: false
}

export const appReducer = (state: AppState, action: Action): AppState => {
  switch (action.type) {
    case ActionType.SET_MENU_NAME:
      return { ...state, menuName: action.payload }
    case ActionType.SET_MENU_ITEMS:
      return { ...state, menuItems: action.payload, menuError: null }
    case ActionType.SET_MENU_LOADING:
      return { ...state, isMenuLoading: action.payload }
    case ActionType.SET_MENU_ERROR:
      return { ...state, menuError: action.payload, menuItems: [] }
    case ActionType.SET_AMP_USER_STATUS:
      return { ...state, ampUserStatus: action.payload }
    case ActionType.SET_USER_DATA:
      return { ...state, userData: action.payload }
    case ActionType.SET_ADVISOR_DATA:
      return {
        ...state,
        advisorData: action.payload,
        advisorDataLoading: false,
        advisorDataError: null
      }
    case ActionType.SET_ADVISOR_DATA_LOADING:
      return { ...state, advisorDataLoading: action.payload }
    case ActionType.SET_ADVISOR_DATA_ERROR:
      return {
        ...state,
        advisorDataError: action.payload,
        advisorDataLoading: false
      }
    default:
      return state
  }
}
